import React from 'react';
import { ColorSchemeIcon } from '../../../Icons';
import { Selector } from '../../../Selector';
import * as Ui from './styles';

/**
 * Componente de item de menu, que manipula o tipo
 * de exibicao de dados de um card
 */
function ColorSchemeMenu({
  /**
   * tipos de charts
   */
  types = [/* {label, value} */],
  /**
   * índice inicial da seleção
   */
  initialTypeIndex = 0,
  /**
   * propaga o evento de seleção do tipo de gráfico
   */
  onTypeChange,
  /**
   * others
   */
  ...props
}) {
  // props from styled-components
  const { className, withData } = props;
  function onChange(changes) {
    if (changes && changes.length === 0) return;
    const newSelection = changes[0];
    if (onTypeChange) onTypeChange(newSelection.value);
  }

  return (
    <Ui.Container className={className} withData={withData}>
      <Ui.Label>
        <Ui.IconContainer>
          <ColorSchemeIcon className="icon" />
        </Ui.IconContainer>
        <span>Esquema de cores (Gráficos)</span>
      </Ui.Label>
      <Ui.Action>
        <Selector
          placeholder="Esquema de cores"
          type="single"
          data={types}
          onChange={onChange}
          initialSelectedIndexes={[initialTypeIndex]}
          disabled={!withData}
        />
      </Ui.Action>
    </Ui.Container>
  );
}

export default ColorSchemeMenu;
